/**
 * Format file size in bytes to human-readable format
 * @param bytes - File size in bytes
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted file size string (e.g., "1.5 MB", "512 KB")
 */
export function formatFileSize(bytes: number, decimals: number = 1): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Format file size with appropriate precision based on size
 * - Bytes: no decimals
 * - KB: 1 decimal if < 10KB, no decimals otherwise
 * - MB and above: 1 decimal
 */
export function formatFileSizeAuto(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);

  if (i === 0) {
    // Bytes - no decimals
    return Math.round(value) + ' ' + sizes[i];
  } else if (i === 1 && value >= 10) {
    // KB >= 10 - no decimals
    return Math.round(value) + ' ' + sizes[i];
  } else {
    // KB < 10 or MB+ - 1 decimal
    return value.toFixed(1) + ' ' + sizes[i];
  }
} 